// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__1Z9Zl","half":"Rating_half__26mVT"};